var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5025 0H3.49818C3.03836 0.000190758 2.58308 0.0909969 2.15837 0.267228C1.73366 0.44346 1.34784 0.701662 1.02296 1.02708C0.69809 1.35249 0.44053 1.73874 0.265004 2.16374C0.0894788 2.58875 -0.000570664 3.04418 2.72156e-06 3.504V9.568C-0.000570638 10.0278 0.0894548 10.4831 0.264935 10.9081C0.440415 11.333 0.69791 11.7193 1.02271 12.0447C1.3475 12.3701 1.73324 12.6283 2.15787 12.8046C2.58249 12.9808 3.03769 13.0717 3.49746 13.072H4.04V16L10.1564 13.072H12.5025C14.4196 13.072 16 11.504 16 9.568V3.504C16 1.568 14.4196 0 12.5025 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5025 0H3.49818C3.03836 0.000190758 2.58308 0.0909969 2.15837 0.267228C1.73366 0.44346 1.34784 0.701662 1.02296 1.02708C0.69809 1.35249 0.44053 1.73874 0.265004 2.16374C0.0894788 2.58875 -0.000570664 3.04418 2.72156e-06 3.504V9.568C-0.000570638 10.0278 0.0894548 10.4831 0.264935 10.9081C0.440415 11.333 0.69791 11.7193 1.02271 12.0447C1.3475 12.3701 1.73324 12.6283 2.15787 12.8046C2.58249 12.9808 3.03769 13.0717 3.49746 13.072H4.04V16L10.1564 13.072H12.5025C14.4196 13.072 16 11.504 16 9.568V3.504C16 1.568 14.4196 0 12.5025 0Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.037b58d5b2c9788a7522d632d39ec208.svg";
export { ForwardRef as ReactComponent };